import { connect } from "react-redux";
import {
  closeLogin,
  sendFormLogin,
  sendRecoverPasswordForm,
  resentValidation,
  resetLoginAttempt,
  resetLoginError,
} from "../../modules/user/actions";
import Login from "../components/Login";

export default connect(
  (state) => ({
    loginAttempt: state.user.loginAttempt,
    localConfigurator: state.configurator.localConfigurator,
    error: state.user.error,
    sendRecoverPasswordFormIsLoading:
      state.loader.sendRecoverPasswordFormIsLoading,
    loginAttempts: state.user.loginAttempts,
    loginErrorCode: state.user.loginErrorCode,
  }),
  (dispatch) => ({
    resetLoginAttempt: () => {
      dispatch(resetLoginAttempt());
    },
    resentValidation: () => {
      dispatch(resentValidation());
    },
    onClose: () => {
      dispatch(closeLogin());
    },
    sendFormLogin: (values) => {
      dispatch(sendFormLogin(values));
    },
    sendRecoverPasswordForm: (values) => {
      dispatch(sendRecoverPasswordForm(values));
    },
    resetLoginError: () => {
      dispatch(resetLoginError());
    },
  }),
)(Login);
